__turbopack_context__.v({
  "destiniIframeDiv": "DestiniBuyButton-module-scss-module__WQC8gq__destiniIframeDiv",
  "destiniOverlay": "DestiniBuyButton-module-scss-module__WQC8gq__destiniOverlay",
  "destiniOverlayCloseIcon": "DestiniBuyButton-module-scss-module__WQC8gq__destiniOverlayCloseIcon",
  "destiniOverlayInnerWrap": "DestiniBuyButton-module-scss-module__WQC8gq__destiniOverlayInnerWrap",
  "destiniOverlayIsOpen": "DestiniBuyButton-module-scss-module__WQC8gq__destiniOverlayIsOpen",
  "fade-in": "DestiniBuyButton-module-scss-module__WQC8gq__fade-in",
  "loadingOverlay": "DestiniBuyButton-module-scss-module__WQC8gq__loadingOverlay",
  "overlayBreadcrumb": "DestiniBuyButton-module-scss-module__WQC8gq__overlayBreadcrumb",
});
